import { render, staticRenderFns } from "./excludeProductCom.vue?vue&type=template&id=7fa29244&scoped=true"
import script from "./excludeProductCom.vue?vue&type=script&lang=js"
export * from "./excludeProductCom.vue?vue&type=script&lang=js"
import style0 from "./excludeProductCom.vue?vue&type=style&index=0&id=7fa29244&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fa29244",
  null
  
)

export default component.exports